import React from 'react';
import { Check } from 'lucide-react';
import { pricingPlans } from '../mock';
import { Button } from './ui/button';

const PricingSection = ({ onOpenPopup }) => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-[#093336] mb-4">Choose Your Package</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Transparent pricing with no hidden fees. Select the package that best fits your needs.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {pricingPlans.map((plan) => (
            <div
              key={plan.id}
              className={`bg-white rounded-2xl shadow-lg p-6 flex flex-col relative ${
                plan.recommended ? 'border-4 border-[#F77F00] transform scale-105' : 'border border-gray-200'
              }`}
            >
              {plan.recommended && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#F77F00] text-white px-4 py-1 rounded-full text-sm font-bold">
                  Recommended
                </div>
              )}
              
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-[#093336] mb-2">{plan.name}</h3>
                <div className="mb-2">
                  <span className="text-4xl font-bold text-[#093336]">{plan.price}</span>
                </div>
                <p className="text-sm text-gray-600">{plan.subtitle}</p>
              </div>
              
              <div className="flex-1 mb-6">
                <ul className="space-y-3 max-h-[300px] overflow-y-auto">
                  {plan.features.map((feature, index) => (
                    <li key={index} className="flex items-start gap-2">
                      <Check size={20} className="text-green-500 flex-shrink-0 mt-0.5" />
                      <span className="text-sm text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
              
              <div className="text-center text-xs text-gray-500 mb-4">
                {plan.note}
              </div>
              
              <Button
                onClick={onOpenPopup}
                className={`w-full py-6 text-lg font-semibold ${
                  plan.recommended
                    ? 'bg-[#F77F00] hover:bg-[#e57300]'
                    : 'bg-[#093336] hover:bg-[#0a4548]'
                }`}
              >
                Get Started
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
